module.exports = __webpack_public_path__ + "img/image-no-upload.png";